// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import EventCheckoutModel from '../../model/event-checkout-model';
import EventCheckoutDTO from '../dto/event-checkout-dto';
import dtoSchema from '../schemas/event-checkout-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import EventRegistrationRequestModel from '../../model/event-registration-request-model';

export default abstract class EventCheckoutModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<EventCheckoutDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.checkoutRequest = data.checkoutRequest ? EventRegistrationRequestModel.toModel(data.checkoutRequest) : undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  checkoutRequest?: EventRegistrationRequestModel;

  static toModel(dto: DeepPartial<EventCheckoutDTO>): EventCheckoutModel;
  static toModel(dto: DeepPartial<EventCheckoutDTO> | undefined | null): EventCheckoutModel | undefined;
  static toModel(dto: DeepPartial<EventCheckoutDTO> | undefined | null): EventCheckoutModel | undefined {
    return dto ? new EventCheckoutModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<EventCheckoutModel> | EventCheckoutModel): EventCheckoutDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      checkoutRequest: unwrapped.checkoutRequest,
    } as EventCheckoutDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for EventCheckoutModel, can not map to EventCheckoutDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
